// extracted by mini-css-extract-plugin
module.exports = {"white":"Logo_white__3bWve","redBlue":"Logo_redBlue__1BFkd"};